import { quizResultMap } from "../data/QuizResultsData";
import { Quiz, QuizResult, QuizResultsType } from "../models/Quiz";

export class QuizHelper {
    getQuizResults(quiz: Quiz): QuizResult {
        let resultsCount = this.getResultsCount(quiz)

        // Find the QuizResultsType with the highest count
        let maxCount = 0;
        let topResult: QuizResultsType = QuizResultsType.BALANCE_BUILDER;

        for (const type in resultsCount) {
            const count = resultsCount[type as QuizResultsType];
            if (count > maxCount) {
                maxCount = count;
                topResult = type as QuizResultsType;
            }
        }

        console.log(resultsCount)

        return quizResultMap[topResult];
    }

    answerTypesToFilterOut(quiz: Quiz): QuizResultsType[] {

        let resultsCount = this.getResultsCount(quiz)
        let tiedResults: QuizResultsType[] = []
        let maxCount = 0

        for (const type in resultsCount) {
            const count = resultsCount[type as QuizResultsType];
            if (count > maxCount) {
                maxCount = count
            }
        }

        for (const type in resultsCount) {
            const count = resultsCount[type as QuizResultsType];
            if (count === maxCount) {
                tiedResults.push(type as QuizResultsType)
            }
        }

        let typesToFilterOut: QuizResultsType[] = [] 

        if(tiedResults.length === 4){
            return tiedResults
        }

        if (tiedResults.length > 1) {
            for (const type in resultsCount) {
                if(!tiedResults.includes(type as QuizResultsType)){
                    typesToFilterOut.push(type as QuizResultsType)
                }
            }
        }

        return typesToFilterOut
    }

    private getResultsCount(quiz: Quiz): Record<QuizResultsType, number> {
        const resultCount: Record<QuizResultsType, number> = {
            [QuizResultsType.VISIONARY_LEADER]: 0,
            [QuizResultsType.BOUNDARY_SETTER]: 0,
            [QuizResultsType.BALANCE_BUILDER]: 0,
            [QuizResultsType.MOMENTUM_MAKER]: 0
        };

        // Loop through each question
        for (const slide of quiz.quizSlides) {
            for (const answer of slide.answers) {
                if (answer.selected) {
                    resultCount[answer.answerType]++;
                    break; // Only one selected per question
                }
            }
        }

        return resultCount
    }
}